var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6016 3.15625C7.631 3.15625 3.60156 7.18569 3.60156 12.1562C3.60156 17.1268 7.631 21.1562 12.6016 21.1562C17.5721 21.1562 21.6016 17.1268 21.6016 12.1562C21.6016 7.18569 17.5721 3.15625 12.6016 3.15625ZM1.60156 12.1562C1.60156 6.08112 6.52643 1.15625 12.6016 1.15625C18.6767 1.15625 23.6016 6.08112 23.6016 12.1562C23.6016 18.2314 18.6767 23.1562 12.6016 23.1562C6.52643 23.1562 1.60156 18.2314 1.60156 12.1562Z",
    fill: "#004FEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6016 11.1562C13.1538 11.1562 13.6016 11.604 13.6016 12.1562V16.1562C13.6016 16.7085 13.1538 17.1562 12.6016 17.1562C12.0493 17.1562 11.6016 16.7085 11.6016 16.1562V12.1562C11.6016 11.604 12.0493 11.1562 12.6016 11.1562Z",
    fill: "#004FEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6016 8.15625C13.6016 8.70853 13.1538 9.15625 12.6016 9.15625C12.0493 9.15625 11.6016 8.70853 11.6016 8.15625C11.6016 7.60397 12.0493 7.15625 12.6016 7.15625C13.1538 7.15625 13.6016 7.60397 13.6016 8.15625Z",
    fill: "#004FEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.39c9949cdb16bbe29557d7ca48958c92.svg";
export { ForwardRef as ReactComponent };